import axios from 'axios'

export default {
    createLead(leadStatus) {
        return axios.post(`zoho/create/${leadStatus}`)
    },
}
